module.exports = __webpack_public_path__ + "img/banner1.cbaf50e4.png";